export default {
	FLAG_CHANGES_OBJECTS: 'companies/:company_id/flag-changes-objects/',
}